import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import CardDetails from './card-details';
const CardProductDetailsPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const cardId = id != null && id !== '' ? Number(id) : NaN;
    if (Number.isNaN(cardId) || cardId < 1) {
        return _jsx(Navigate, { to: "..", replace: true });
    }
    return (_jsx(CardDetails, { cardId: cardId, onClose: () => navigate('..'), isPageView: true }));
};
export default CardProductDetailsPage;
